import React, {useState, useContext, useEffect} from 'react';
import __ from "lodash";
import { FormControl, FormGroup, Grid, useTheme } from "@material-ui/core";
import { FormDialog, LabelledPaper, MaskedText } from '../../../controls';
import SystemContext from "../../../SystemContext";
import ScrMessageView from "./ScrMessageView";
import SendSlotValidator from "../validators/SendSlotValidator";
import { useSendSlotRequest } from "../../../services/slots";
import {getDefaultValues} from "../../../functions/TemplateHelperFunctions";

const formatChars={
  "U": "[A-Z]",
  "A": "[A-Z0-9]",
  "a": "[A-Za-z0-9]",
  "9": "[0-9]",
  "D": "[0-9.]",
  "-": "-",
  "x": "."
}

const paperProps = {
  style: {
    backgroundColor: "#f8f8f8",
    boxShadow: 'none',
  }
}

const defaultLabelledPaperProps = {
  checkChildren: true,
  style: {display: "block", border: "solid 1px #b9b9b9" },
  labelStyle: {background: "#f0f0f0"},
  collapsible: false,
}

const SendSlotRequestDialog = (_props) => {
  const props = {
    canEdit: false,
    ..._props,
  }
  const classes = props.classes;
  const theme = useTheme();
  const [dialogStates, setDialogStates] = useState(props.dialogStates);
  const [slotRequest, setSlotRequest] = useState(props.request);
  const [slotRecord, setSlotRecord] = useState(props.record);
  const [originalSlotRecord] = useState(props.originalRecord);
  const [requestSent, setRequestSent] = useState(false);

  const [alert, setAlert] = useState({
    open: false,
    severity: "error",
    message: "",
  });

  if ((props.request && !slotRequest) || (!props.request && slotRequest)) {
    setSlotRequest(props.request);
  }

  const SystemData = useContext(SystemContext);

  const handleUpdateSlot = useSendSlotRequest();
  const extraKeys = [];

  useEffect(()=> {
    const getDefaults = async () => {
      const defaults = await getDefaultValues(SystemData, "slots", "Send Slot");
      if (!defaults)
        return null;
      return defaults;
    }

    getDefaults().then(defaults => {
      if (slotRequest && defaults && __.has(defaults, "ccList")) {
        if (!__.has(slotRequest, "carbonCopy") || slotRequest.carbonCopy === "")
        setSlotRequest({...slotRequest, carbonCopy: defaults.ccList});
      }
    })
  }, [slotRequest]);


  const getButtons = () => {
    if (requestSent) {
      return (
        {
          save:{icon: "send", key: "Save", label: "Re-Send", color: "primary", disabled: (status)=>{return status.error}},
          cancel:{icon: "cancel", key: "Cancel", label: "Close", color: "primary"},
        }
      );
    }
    return (
      {
        save:{icon: "send", key: "Save", label: "Send", color: "primary", disabled: (status)=>{return status.error}},
        cancel:{icon: "cancel", key: "Cancel", label: "Cancel", color: "primary"}
      }
    );
  }

  return (
    <div key="formContainer" style={{width: "100%", textAlign:"left" }}>
      {slotRequest && __.has(slotRequest, "slotActionCode") && __.has(slotRequest, "carbonCopy")
        ?
          <FormDialog
            key="send slot request"
            title={`Send Slot Request${dialogStates.airport ? " at " + dialogStates.airport : ""}`}
            message=""
            open={dialogStates.showDialog}
            dialogOptions={{maxWidth: "md", fullWidth: true, PaperProps: paperProps }}
            record={slotRequest}
            validator={SendSlotValidator}
            validatorPosition="top"
            alert={alert}
            formHeightOffset={320}
            titleBarStyle={{backgroundColor: '#3f3f3f', color: theme.palette.primary.main}}
            //buttonBarStyleOverride={{position: "relative", width: "calc(100% - 15px)", backgroundColor: "#ffffff", borderTop: `1px solid ${props.fullPageStyle?"grey":"lightgrey"}`, ...props.fullPageStyle}}
            //formBodyStyle={{...props.fullPageStyle}}
            //style={{...props.fullPageStyle}}
            buttons={getButtons()}
            onChange={(state) => {
              if (state.buttonPressed === "cancel") {
                setSlotRecord(props.record);
                setDialogStates({showDialog: false});
                if (props.close)
                  props.close();
              }
              if (state.buttonPressed === "save") {
                SystemData.toggleLoadingProgress(true);

                const updatedRecord = {...state.record, ...slotRecord, status: "REQUESTED"};
                if (["C","M"].includes(state.record.slotActionCode)) {
                  updatedRecord["slotPeriodFrom"] = state.record.slotPeriodFrom;
                  updatedRecord["slotPeriodTo"] = state.record.slotPeriodTo;
                  updatedRecord["days"] = state.record.days;
                }

                handleUpdateSlot.mutate({
                  extraKeys,
                  record: updatedRecord,
                  postSuccess: () => {
                    setRequestSent(true);
                    SystemData.toggleLoadingProgress(false);
                    setAlert({ severity: "info", open: true, message: `Slot Request sent`, timeOut: 5 });
                  },
                  postError: (data) => {
                    SystemData.toggleLoadingProgress(false);
                    if (data.errorMessage) {
                      SystemData.alert("Error", `${data.errorMessage}`);
                    } else {
                      SystemData.alert("Error", `An Unexpected Error has occurred sending the Slot Request`);
                    }
                  }
                });

              } else {
                console.log("Unhandled FormDialog onChange");
              }
            }}
          >
            <Grid container checkChildren={true} spacing={3}>
              <Grid item xs={12} checkChildren={true} row>
                <LabelledPaper {...defaultLabelledPaperProps} label="" >
                  <FormControl checkChildren={true} key="FC-addresses" style={{display: "block" }}>
                    <FormGroup checkChildren={true} key="FG-addresses" style={{padding: "8px 8px 8px 8px"}}>
                      <Grid container checkChildren={true} spacing={3}>

                        <Grid item xs={12} checkChildren={true}>
                          <MaskedText
                            id="slotBookingEmail"
                            label="To"
                            inputLabelProps={{ shrink: true }}
                            style={{width: "100%"}}
                            mask={"x".repeat(200)}
                            maskChar={""}
                            alwaysShowMask={false}
                            formatChars={formatChars}
                            forceUpperCase={false}
                          />
                        </Grid>
                        <Grid item xs={12} checkChildren={true}>
                          <MaskedText
                            id="carbonCopy"
                            label="CC"
                            inputLabelProps={{ shrink: true }}
                            style={{width: "100%"}}
                            mask={"x".repeat(200)}
                            maskChar={""}
                            alwaysShowMask={false}
                            formatChars={formatChars}
                            forceUpperCase={false}
                          />
                        </Grid>
                        <Grid item xs={12} checkChildren={true}>
                          <MaskedText
                            id="slotSubject"
                            label="Subject"
                            inputLabelProps={{ shrink: true }}
                            style={{width: "100%"}}
                            mask={"x".repeat(200)}
                            maskChar={""}
                            alwaysShowMask={false}
                            formatChars={formatChars}
                            forceUpperCase={false}
                          />
                        </Grid>
                      </Grid>
                    </FormGroup>
                  </FormControl>
                </LabelledPaper>
              </Grid>

              {record => {
                return (
                  <Grid item xs={12} checkChildren={true}>
                    <LabelledPaper {...defaultLabelledPaperProps} label={`Message Body`} >
                      <FormControl checkChildren={true} key="FC-slotmessage" style={{display: "block" }}>
                        <FormGroup checkChildren={true} key="FG-slotmessage" style={{padding: "8px 8px 8px 8px"}}>
                          <ScrMessageView slot={record} originalSlot={originalSlotRecord} suppressTitle resend={props.resend}/>
                        </FormGroup>
                      </FormControl>
                    </LabelledPaper>
                  </Grid>
              )}}
            </Grid>
          </FormDialog>
        :
          <></>
      }
    </div>
  );
}

export default SendSlotRequestDialog;
